import React from 'react';
import {MainBody} from './components/MainBody';
import {ModalProvider} from 'react-use-modal';
import './componentCss/app.scss';

import AdapterMoment from '@mui/lab/AdapterMoment';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MuiTheme from './materialTheme';

import {store} from './redux/store/store';
import {Provider} from 'react-redux';

import {PersistGate} from 'redux-persist/integration/react';
import {persistStore} from 'redux-persist';
import {Grid} from '@mui/material';

let persistor = persistStore(store);

export function App(props) {
    return (
        <Grid container className="app" alignItems="stretch" justifyContent="center">
            <Grid item xs={12} display="flex">
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <MuiTheme>
                                <ModalProvider>
                                    <MainBody />
                                </ModalProvider>
                            </MuiTheme>
                        </LocalizationProvider>
                    </PersistGate>
                </Provider>
            </Grid>
        </Grid>
    );
}
